<script setup lang="ts">
  import { TabsContent, type TabsContentProps } from 'reka-ui'
  import { computed, type HTMLAttributes } from 'vue'
  import { cn } from '../../../lib/utils'

  const props = withDefaults(
    defineProps<
      TabsContentProps & { class?: HTMLAttributes['class']; tabindex?: string }
    >(),
    {
      tabindex: '-1'
    }
  )

  const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props

    return delegated
  })
</script>

<template>
  <TabsContent
    data-slot="tabs-content"
    :class="cn('flex-1 outline-none', props.class)"
    v-bind="delegatedProps"
    :tabindex
  >
    <slot />
  </TabsContent>
</template>
